import { render, staticRenderFns } from "./HomeCategory.vue?vue&type=template&id=6346e51e&scoped=true&"
import script from "./HomeCategory.vue?vue&type=script&lang=js&"
export * from "./HomeCategory.vue?vue&type=script&lang=js&"
import style0 from "./HomeCategory.vue?vue&type=style&index=0&id=6346e51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346e51e",
  null
  
)

export default component.exports